<template>
    <div class="embed-responsive embed-responsive-16by9">
        <iframe loading="lazy" frameborder="0" allowfullscreen="allowfullscreen" class="embed-responsive-item" :src="url"></iframe>
    </div>
</template>

<script>
export default {
     data() {
            return {
                valid: false,
                url: 'https://www.youtube.com/embed/hy3LlGBZqI4',
            }
     } 
}
</script>
<style scoped>


</style>